import * as Yup from 'yup';

export const getProductShape = () => ({
  name: Yup.string().required('Informe o tipo'),
});
